import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import SideDrawer from "./SideDrawer";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
//   import SideIcon from "./SideIcon";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BsFileEarmarkText } from "react-icons/bs";
import MoreFilterInternalView from "../../../components/containers/MoreFilterInternalView";
import { useNavigate } from "react-router-dom";

const MoreViewInternalDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const [typeResult, setTypeResult] = useState("public");
  const navigate = useNavigate()
  return (
    // <RootComponents>
      <>
      <Box className={styles.search_candidate_stucture}>
        <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Candidate Details
          </Typography>
          <span onClick={handleShow}>
            <Typography sx={{ color: customTextColor }}>
              Kevin Macklin - Submission History
            </Typography>
            <IoIosArrowBack
              className={styles.arrow_icon}
              style={{ color: "rgb(147 145 145)", fontSize: "18px" }}
            />
          </span>
        </Box>
        {/*   
          <SideIcon handleClose={handleCloseSide} side={side} /> */}

        <Grid container className={styles.verification_phase}>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor, border: "none !important" }}
          >
            <Typography sx={{ marginLeft: "0 !important" }}>
              <b>Active Since 12 May 2024
              </b>{" "}

            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <b>Last Update 12 May 2024 </b>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor }}
          >
            <Typography sx={{ cursor: "pointer" }}>
              <b>95% Searching Matches </b>
            </Typography>
            <BsThreeDotsVertical onClick={handleThreeDotsClick} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        {isProfileVisible && (
          <Box className={styles.profile_and_submit}>
            <Box>
              <Typography>
                <b>Profile Uploaded By</b>
              </Typography>
              <Typography sx={{ marginTop: '10px !important' }}>
                Name: <b>Harish *****</b>
              </Typography>
              <Typography>
                Designation: <b>Sr. Recruiter</b>
              </Typography>
              <Typography>
                Categories:
                <b>Mutual 21</b>
              </Typography>
            </Box>
            <Box className={styles.phase2} sx={{ marginTop: '20px !important' }}>
              <BsFileEarmarkText style={{ cursor: 'pointer', fontSize: '50px', color: '#2e6ca3', marginBottom: '5px' }} />
              <Typography >
                <b>Get Resume</b>
              </Typography>

            </Box>
          </Box>
        )}

        <Box className={styles.matches_and_submit}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ color: customTextColor }}
            >
              <Box>
                <Typography>
                  Name : <b>Kevin Macklin</b>
                </Typography>

                <Typography>
                  Experience : <b>10 Years</b>
                </Typography>
                <Typography>
                  E-Mail ID: <b>malkinmacklin0127@gmail.com</b>
                </Typography>
                <Typography>
                  Current Location : <b>Dallas Taxes</b>
                </Typography>
                <Typography>
                  Organization : <b>ABC Technologies Pvt Ltd</b>
                </Typography>

                <Typography>
                  Qualifications : <b>B Tech</b>
                </Typography>
                <Typography >
                  Prefer Tax Term : <b>Any</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  LinkedIn Profile:  <b>Kevinmacklin.linkedin.com</b>
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{
                color: customTextColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography>
                  Job Profile : <b>Lead Java Developer</b>
                </Typography>
                <Typography>
                  Phone No:
                  <b>212-770-3012</b>
                </Typography>
                <Typography>
                  Work Authorization : <b> Green Card</b>
                </Typography>
                <Typography>
                  Prefer Location : <b>San Club California, CA</b>
                </Typography>
                <Typography>
                  Domain : <b>Healthcare, Retail, Banking</b>
                </Typography>
                <Typography>
                  University & Year : <b>Boston Texas,2024</b>
                </Typography>
                <Typography sx={{ marginBottom: "0 !important" }}>
                  Current Rate : <b>100$</b>
                </Typography>
              </Box>

              <Box>
                <span onClick={handleSide} style={{ cursor: "pointer" }}>
                  <Typography>
                    <div
                      style={{
                        backgroundColor: "#e1eaf0",
                        padding: "7px",
                        borderRadius: "3px",
                      }}
                    >
                      <IoIosSearch style={{ fontSize: "22px" }} />
                    </div>
                  </Typography>
                </span>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiMailboxLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <CiMobile3 style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
                <Typography>
                  <div
                    style={{
                      backgroundColor: "#e1eaf0",
                      padding: "7px",
                      borderRadius: "3px",
                    }}
                  >
                    <PiLinkedinLogoLight style={{ fontSize: "22px" }} />
                  </div>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Grid container sx={{ backgroundColor: "#fff", }}>
          <Grid item xs={6} sm={6} md={10} lg={10} >
            <Box className={styles.list_details} >
              <Typography sx={{ marginBottom: "20px !important" }}>
                Excellency in skills
              </Typography>
              <Grid container sx={{ fontweight: "600" }}>
                <Grid item xs={6} sm={6} md={2.3} lg={2.3}>
                  <Box sx={{ color: customTextColor }}>
                    <Typography>Hibernate 2 Years </Typography>
                    <Typography sx={{ marginBottom: '0 !important' }}>Spring Boot 4 Years</Typography>

                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.5}
                  lg={3.5}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> MVC 1 Years</Typography>
                    <Typography sx={{ marginBottom: '0 !important' }}>Spring Boot 4 Years</Typography>

                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Golang 2 Years </Typography>
                    <Typography sx={{ marginBottom: '0 !important' }}>Spring Boot 4 Years</Typography>

                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3.1}
                  lg={3.1}
                  sx={{ borderLeft: "2px solid white", paddingLeft: "20px" }}
                >
                  <Box sx={{ color: customTextColor }}>
                    <Typography> Hibernate 2 Years </Typography>
                    <Typography sx={{ marginBottom: '0 !important' }}>Spring Boot 4 Years </Typography>

                  </Box>

                </Grid>
              </Grid>

            </Box>
          </Grid>

          <Grid item xs={6} sm={6} md={2} lg={2} style={{ alignSelf: 'end', padding: '0px 18px 16px 0' }}>
            <Box className={styles.send_back_btns}>
              <button
                     onClick={() => navigate('/send-job-internal')}
                style={{
                  backgroundColor: "#3856a6",
                  color:'#fff',
                  cursor:'pointer',
                  padding:'7.5px 15px',
                  borderRadius:'3px',
                  border:'none'
                }}
              >
                Send Job

              </button>
            </Box>
          </Grid>
        </Grid>
        {/*         
          <Box className={styles.profile_status_details_btns}>
            <img src={profile_image} alt="" />
  
            <Box className={styles.add_back_btns}>
              <button
                style={{
                  backgroundColor: "#2e75b6",
                  marginRight: "350px",
                }}
              >
                View Contact
              </button>
  
              <Box>
                <button
                  onClick={handleClickOpen}
                  style={{
                    backgroundColor: "#00b050",
                    marginLeft: "150px",
                  }}
                >
                  Send Requirement
                </button>
              </Box>
           
            </Box>
          </Box> */}

        <SideDrawer
          handleShow={handleShow}
          handleClose={handleCloseShow}
          show={show}
        />
      </Box>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "0 14px 0 14px" }}
      >
        <Box className={styles.choose_resume}>
          <Typography
   
            sx={
              typeResult === "public"
                ? { color: "#1991e0" }
                : { color: customTextColor }
            }
          >
            Private Matching 17
          </Typography>
          <Typography
        
            sx={
              typeResult === "internal"
                ? { color: "#1991e0" }
                : { color: customTextColor }

            }
          >
            Internal Matching 170
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ padding: "14px 14px 0 14px" }}
      >
        {typeResult === "public" ? (
          <>
            <MoreFilterInternalView
              name="Himanshu Sekhar"
              job=" Lead Java Developer"
              location="Noida Delhi, DL"
              work="Green Card"
              skills="Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Action"
              matches="Mathes 97%" />
            <MoreFilterInternalView
              name=" Pratik Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK"
              work="Green Card"
              skills=" Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Action"
              matches="Mathes 95%" />
            <MoreFilterInternalView
              name=" Pratik Reddy"
              job=" Lead Java Developer"
              location="Kolkata, KK"
              work="Green Card"
              skills=" Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years | GO 2 Years"
              btn1="View Profile"
              btn2="Action"
              matches="Mathes 95%" />
          </>
        ) : (
          <></>
        )}
      </Grid>
      <Box className={styles.select_search_result_btns}>
        <button style={{ alignSelf: "flex-end " }}>Select All</button>
      </Box>
      {/* <Box className={styles.select_search_result_btns}>
          <button style={{ alignSelf: "flex-end " }}>Select All</button>
        </Box> */}
        </>
    // {/* </RootComponents> */}
  );
};

export default MoreViewInternalDetails;
